export default "__VITE_ASSET__CVtnX0UU__"